import create from './create';
import createOption from './create-option';
import deleteApi from './delete';
import deleteOption from './delete-option';
import deleteTransaction from './delete-transaction';
import deleteUser from './delete-user';
import detail from './detail';
import edit from './edit';
import editOption from './edit-option';
import grantUser from './grant-user';
import interestRegistrations from './interest-registrations';
import list from './list';
import options from './options';
import registerInterest from './register-interest';
import revokeUser from './revoke-user';
import transactions from './transactions';
import updateInterestRegistration from './update-interest-registration';
import users from './users';

const ApiCall = {
  list,
  detail,
  create,
  edit,
  delete: deleteApi,
  users,
  options,
  createOption,
  editOption,
  deleteOption,
  grantUser,
  registerInterest,
  interestRegistrations,
  revokeUser,
  deleteUser,
  transactions,
  deleteTransaction,
  updateInterestRegistration,
};

export default ApiCall;
